import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/mfa/dialog-mfa-recovery-keys.hbs';
import item_template from '@/../templates/mfa/mfa-code-item.hbs';
import MFAValidateDialog from '@/views/dialogs/validate_mfa';

var globalCh = Radio.channel('global');


// Maximum number of recovery keys available at one time
var MAX_KEYS = 10;

var item_view = Marionette.View.extend({
    className: 'code-item',
    tagName: 'li',
    template: Handlebars.compile(item_template),
});

function create_codes_view(collection) {
    return new Marionette.CollectionView({
        className: 'codes-list well',
        tagName: 'ul',
        collection: collection,
        childView: item_view,
    });
}

function download_keys(collection) {
    var keys_only = collection.pluck("token");
    var file = new Blob([keys_only], { type: 'application/json' });
    var url = URL.createObjectURL(file);
    var dl_link = $(document.getElementsByClassName('download')) || $(document.getElementById('download-keys'));

    dl_link.attr('href', url);
    dl_link.attr('download', 'recovery_keys.txt');
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 0);
}

function print() {
    window.print();
    return;
}

var View = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        recovery_codes_region: '.recovery-codes-region',
        download: '.download',
        print: '.print',
        success_done: '.success-done',
        cancel: '.cancel',
        regenerate_codes: '.regenerate-codes'
    },
    regions: {
        recovery_codes: '@ui.recovery_codes_region',
    },
    events: {
        'click @ui.download': function (e) {
            download_keys(this.collection);
        },
        'click @ui.print': function (e) {
            print();
        },
        'click @ui.regenerate_codes': function() {
            this.regenerate_codes();
        }
    },
    initialize: function () {
        this.destroyOnClose();
    },
    onRender: function () {
        this.ui.regenerate_codes.hide();
        this.showChildView('recovery_codes', create_codes_view(this.collection));

        if (this.recovery_keys_used_up()) {
            this.ui.regenerate_codes.show();
            this.ui.success_done.hide();
        }
    },
    recovery_keys_used_up: function() {
        var keys_used = 0;
        this.collection.each(function (el) {
            // If any of the tokens have a null value, they have not been used so do not render regenerate button
            if (el.get('claimed_at') !== null) {
                keys_used++;
            }
        });

        if (keys_used >= MAX_KEYS) {
            return true;
        }
        return false;
    },
    regenerate_codes: function() {
        // Launch password auth modal
        var view = new MFAValidateDialog({
            model: this.model,
            title: 'Regenerate Recovery Codes',
            description: 'To regenerate recovery codes, please verify your current password.',
            regenerate_codes: true,
        });
        globalCh.request('showDialog', view);
    },
});
export default View;

